(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("Autocomplete", ["react"], factory);
	else if(typeof exports === 'object')
		exports["Autocomplete"] = factory(require("react"));
	else
		root["Autocomplete"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__680__) {
return 